import Layout from '../../layout/default';

const Subscriptions = () => {
  return (    
    <Layout>
    <div>subscriptions</div> 
    </Layout>
  )
}

export default Subscriptions